import {Component, ComponentType, FC} from "react";
import { Link } from 'react-router';
import { RouterItemInfo } from '@interfaces/control-panel';
import { Helmet } from 'react-helmet';
import { useSelector, shallowEqual } from 'react-redux';
import { ReduxStore } from '@interfaces/store';
import { PageRouting } from '@interfaces/panel/routing';
import {Card, Col, Row, Breadcrumb} from "react-bootstrap";
import {Flex} from "@components/falcon/common";


import barChart from '../../assets/img/illustrations/crm-bar-chart.png';
//import lineChart from '../../assets/img/illustrations/crm-line-chart.png';

const withPage = <T extends {}>(View: ComponentType<T>) => {

    interface BlankProps {
        route_info: PageRouting;
    }

    return class extends Component<BlankProps & T> {
        render() {
            const { route_info: { name, items, title, code } } = this.props;

            return (
                <>
                    <Helmet title={title} />
                    <Card className="bg-100 shadow-none border mb-3">
                        <Card.Body className="py-0">
                            <Row className="g-0 justify-content-between">
                                <Col sm="auto">
                                    <Flex alignItems="center">
                                        <img src={barChart} width={90} alt="..." className="ms-n4"/>
                                        <div>
                                            <h4 className="text-primary fw-bold mb-0">{name}</h4>
                                            <h6 className="text-primary fs-10 mb-0"><Breadcrumbs items={items} currentName={name} codeName={code} /></h6>
                                        </div>

                                    </Flex>

                                </Col>
                            </Row>
                            <Row>

                            </Row>
                        </Card.Body>
                    </Card>

                    <View {...this.props} />
                </>
            )
        }
    }
}

interface BreadcrumbsProps {
    items: RouterItemInfo[];
    currentName?: string;
    codeName?: string;
}

const Breadcrumbs: FC<BreadcrumbsProps> = ({ items, currentName, codeName }) => {

    const infos = useSelector(({ panel }: ReduxStore) => panel.breadcrumbs, shallowEqual);
    const bname = (codeName && infos[codeName] && infos[codeName].name) || currentName;

    return (
        <Breadcrumb>
            {
                items.map(({ name, code, useLink, link }, idx) => {

                    const bc = code && infos[code];
                    name = (bc && bc.name) || name;
                    link = (bc && bc.link) || link;

                    if(!name) {
                        return null;
                    }

                    if(link && useLink) {
                        return (
                            <Breadcrumb.Item key={idx} linkAs={Link} linkProps={{ to: `/consumer${link}` }}>
                                {name}
                            </Breadcrumb.Item>
                        )
                    }

                    return (
                        <Breadcrumb.Item key={idx}>
                            {name}
                        </Breadcrumb.Item>
                    )
                })
            }
            <Breadcrumb.Item active>{bname}</Breadcrumb.Item>
        </Breadcrumb>
    )
}

export default withPage;